// Libs
import React from 'react'
let PropTypes = React.PropTypes
// Styles
import * as style from '../../auditorias/programacion-mensual/FormularioAgregarAuditoria.css'

export class FormularioAgregarCapturas extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            locales: [],
            errores:{
                errorIdCliente: '',
                errorNumeroLocal: ''
            },
            pegados: {
                pegadoConProblemas: [],
                conteoTotal: 0,
                conteoCorrectos: 0,
                conteoProblemas: 0
            },
            inputPegar_error: '',
            mostrarExcel: false
        }
        this.mostrarPegarExcel = ()=>{
            this.setState({
                mostrarExcel: true
            })
        }
        this.ocultarPegarExcel = ()=>{
            this.setState({
                mostrarExcel: false
            })
        }
    }
    /**
     * Cambio en los campos del formulario
     */
    setModoIngreso(modo){
        if(modo!==this.state.modoIngreso){
            this.setState({modoIngreso: this.state.modoIngreso==='manual'? 'excel' : 'manual'})
        }
    }
    getOpcionesSeleccionadas(){
        return {
            idCliente: this.state.idClienteSeleccionado,
            mes: this.state.mesSeleccionado
        }
    }
    agregarLocalesAlPegar(event){
        event.preventDefault()
        // cuando se pegue un elemento, separar separar las filas por el "line feed" '\n'
        event.clipboardData.items[0].getAsString(texto=>{
            // separar cada una de las filas '\n'
            let rows = texto.trim().split('\n')
            rows = rows.filter(row=>row!=='')
            let datosCapturas = rows.map(row=>{
                let datos = row.trim().split('\t')
                return {
                    idArchivoFinalAuditoria: this.props.idArchivoFinalAuditoria,
                    idAuditoria: this.props.idAuditoria,
                    tienda: datos[0],
                    fecha_auditoria: datos[1],
                    auditor: datos[2],
                    rut_auditor: datos[3],
                    qf: datos[4],
                    rut_qf: datos[5],
                    items: datos[6],
                    sku: datos[7],
                    barra: datos[8],
                    descriptor: datos[9],
                    laboratorio: datos[10],
                    lote: datos[11],
                    fecha_venc: datos[12],
                    imagen: datos[13],
                    fecha_captura: datos[14],
                    hora_captura: datos[15],
                    doble_foto: datos[16],
                    revalidado: datos[17],
                    cod_vendedor: datos[18],
                    estado: datos[19]
                }
            })
            this.context.pegarCapturasVencimiento(datosCapturas)
            this.setState({
                mostrarExcel: false
            })
        })
    }
    render(){
        return <div className="form">
            <button type="button" className={'btn btn-xs btn-success pull-right'} onClick={this.state.mostrarExcel === false? this.mostrarPegarExcel : this.ocultarPegarExcel} disabled><span className="glyphicon glyphicon-paste"></span> Pegar Desde Excel</button>
            <div className="row">
                {/* ========= OPCIONES PARA AGREGAR DESDE EXCEL ========= */}
                <div style={{display: this.state.mostrarExcel? '':'none'}}>
                    {/* Locales */}
                    <div className='col-sm-10 form-group '>
                        <label className="control-label" htmlFor="locales">Pega tus capturas aquí</label>
                        <input className="form-control" type="text" name="locales" placeholder="pegar acá los datos de la captura vencimiento"
                               onPaste={this.agregarLocalesAlPegar.bind(this)}
                               //disabled={this.props.puedeAgregar? '':'disabled'}/>
                               /> 
                        <p style={{marginTop: '1em'}}>
                            <b>TIENDA</b> - <b>FECHA AUDITORIA (DD-MM-YYYY)</b> - <b>AUDITOR</b> - <b>RUT AUDITOR</b> - <b>QF</b> - <b>RUT QF</b> - <b>ITEM</b> - <b>SKU</b> - <b>BARRA</b> - <b>DESCRIPTOR</b> - <b>LABORATORIO</b> - <b>LOTE</b> -<b>FECHA VENCIMIENTO (MM-AAAA)</b> - <b>IMAGEN</b> - <b>FECHA CAPTURA (DD-MM-YYYY)</b> - <b>HORA CAPTURA</b> - <b>DOBLE FOTO(0 ó 1)</b> - <b>REVALIDADO(0 ó 1)</b> - <b>RUT VENDEDOR</b> - <b>ESTADO(OBLIGATORIO o RESERVA)</b>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    }
}

FormularioAgregarCapturas.contextTypes = {
    pegarCapturasVencimiento: PropTypes.func
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/revision/FormularioAgregarCapturas.jsx